import {
    IonButton, IonCheckbox, IonCol, IonContent, IonGrid, IonInput, IonItem, IonLabel, IonPage, IonRadio, IonRadioGroup, IonRow, IonText, useIonViewWillEnter, useIonViewWillLeave
} from "@ionic/react";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";

import { Link } from "react-router-dom";
import Footer from "../../../components/Footer";
import UserTerms from "../../../components/UserTerms";
import { User } from "../../../models/data";
import { translation } from "../../../models/translation";
import { fetchSingleFundraiser } from "../../../services/fundraise_service";
import { fetchOrgList } from "../../../services/org_service";

interface Props {
    user: User
}


interface DonateForm {
    pickOrg: string | null,
    altOrg: string | null,
    date: string,
    freq: string,
    amount: number,
    tip:number,
    anom: boolean,
    beneficiary_type: string
}
const DonateToFundraiserPms: React.FC<Props> = () => {

    const history = useHistory();

    const location=useLocation()

    const siteText = translation();

    const lan = siteText.lan.replace("/", "")

    const [orgList, setOrgList] = useState<any[]>();

    const params = new URLSearchParams(location.search)

    const fundraiserId=  params.get('id');
    
    const tomorrow = new Date();

    tomorrow.setDate(new Date().getDate() + 1);

    const year = tomorrow.getFullYear();

    let month = `${tomorrow.getMonth() + 1}`;
    let day = `${tomorrow.getDate()}`;

    if (month.length < 2) { month = 0 + month };
    if (day.length < 2) { day = 0 + day };

    const minDate = `${year}-${month}-${day}`;

    const tips = [
        {
            name: 'none',
            value: 0.00,
            label: '0%'
        },
        {
            
            name: 'basic',
            value: 0.03,
            label: '3%'
        },
        {
            name: 'middle',
            value: 0.05,
            label: '5%'
        },
        {
            name: 'basic',
            value: 0.07,
            label: '7%'
        }
    ]

    const [tip, setTip] = useState<number>(() => {
        return tips[1].value
    });

    const [amount, setAmount] = useState(()=>{return 0})

    const [anonymous, setAnonymous] = useState(false)

    const [donateData] = useState<DonateForm>({
        pickOrg: fundraiserId,
        altOrg: null,
        date: minDate,
        freq: 'single',
        amount: 0,
        tip:0,
        anom: false,
        beneficiary_type: "fundraiser"
    })

    const [fundraiser,setFundraiser]=useState<any>()


    const [terms, agreeTerms] = useState(false);

    const [userTerms, showUserTerms] = useState<boolean>(false);

    useIonViewWillEnter(()=>{
        getFundraiser()
    },[fundraiserId])

    useEffect(() => {
        getOrgList();
        return () => { };
    }, [])

    const getOrgList = async () => {
        let orgs = await fetchOrgList();
        setOrgList(orgs.message);
    }

    const getFundraiser=async()=>{
        if (fundraiserId) {
            fetchSingleFundraiser(fundraiserId).then(m => {
                if (m.message) {
                    setFundraiser(m.message)
                }
            })
        }
    }

    const commissionToCash=(value:any)=>{
        let commission=amount*value
        commission=Math.round(commission*100)/100
        return commission
    }

    const amountSummary=(amount:any,commission:any)=>{
        let summary=+amount+(amount*commission)
        summary=Math.round(summary*100)/100
        return summary
    }


    /*Close open user terms  */
    const toggleUserTerms = () => {
        let current = userTerms;
        showUserTerms(!current);
    }

    const onSubmit = (event: any) => {
        event.preventDefault();
        if (!amount) return
        donateData.amount = (+amount + (amount * tip))
        donateData.tip=amount*tip
        donateData.anom = anonymous
        let state = {
            data: donateData
        }
        history.push(`/${lan}/account/donate_process_V2`, state);


    }
    return (
        <IonPage>
            <IonContent>

                {!userTerms ?
                    <IonGrid className="innerBody">
                        <IonRow >
                            <IonCol className="ion-margin-top" offsetSm="1"  sizeSm="10" sizeMd="8">
                                {fundraiser &&<h1 className="h2">{siteText.fundraiseDonateStartTitle.replace("%%title%%",fundraiser.title.rendered)}</h1>}
                                
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className="ion-margin-top" offsetSm="1" sizeSm="10" sizeMd="8">
                                <form onSubmit={e => onSubmit(e)}>

                                    <IonLabel position="stacked">{siteText.donateDirectlyStartAmountLabel}</IonLabel>
                                    <IonInput className="ion-margin-bottom ion-margin-top" value={amount} onIonChange={(e: any) => setAmount(+e.detail.value)} placeholder={siteText.donateDirectlyStartAmountPlh} min="0" type="number"></IonInput>
                                    <h4>{siteText.donateDirectlyPaySubtotalText} {amount ? amountSummary(amount,tip): 0} CHF</h4>

                                    <p>{siteText.donateDirectlyPayTipRequest}</p>
                                    <IonRadioGroup style={{ display: 'flex' }} className="ion-margin-bottom" value={tip} onIonChange={(e: any) => setTip(e.detail.value)}>
                                        {tips.map((m, key) =>
                                        <IonItem className="ion-margin-end" lines="none" key={key}>
                                            <IonLabel className="ion-margin-end">{commissionToCash(m.value)} CHF</IonLabel> <IonRadio value={m.value}></IonRadio>
                                        </IonItem>)}
                                    </IonRadioGroup>


                                    <IonItem lines="none" className="borderedInput">
                                        <IonLabel>
                                            {siteText.donateDirectlyStartAnonymousCheck}
                                        </IonLabel>
                                        <IonCheckbox checked={anonymous} onIonChange={(e: any) => { setAnonymous(e.detail.checked) }} slot="start" />
                                    </IonItem>

                                    <IonCol sizeMd="4">
                                        <IonItem lines="none" className="borderedInput">
                                            <IonLabel className="ion-text-wrap"> <Link to="terms_of_use" onClick={e => { e.preventDefault(); toggleUserTerms(); }}>{siteText.donateDirectlypayConfirm}</Link> </IonLabel>
                                            <IonCheckbox checked={terms} onIonChange={() => { agreeTerms(!terms) }} slot="start" />
                                        </IonItem>
                                    </IonCol>
                                    <IonButton disabled={!terms || amount===0} strong slot="end" className="ion-margin-top" type="submit">
                                        <IonText color="light">
                                            {siteText.donateDirectlyStartSubmitTxt}
                                        </IonText>
                                    </IonButton>
                                </form>
                            </IonCol>
                        </IonRow>
                    </IonGrid> :
                    <IonGrid>
                        <UserTerms goBack={toggleUserTerms}></UserTerms>
                    </IonGrid>
                }
                <Footer></Footer>
            </IonContent>

        </IonPage>
    )

}

export default DonateToFundraiserPms;